import { render, staticRenderFns } from "./item-list-text-type.vue?vue&type=template&id=8a054974&scoped=true&lang=pug&"
import script from "./item-list-text-type.vue?vue&type=script&lang=ts&"
export * from "./item-list-text-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a054974",
  null
  
)

export default component.exports